























import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

import {UpgradeState, UpgradeStateLabels} from '@/model/system/update/UpgradeState';

import SystemInfoStore from '@/store/system/SystemInfo.store';
import SystemUpgradeStore from '@/store/system/SystemUpgrade.store';
import SystemUpdateStore from '@/store/system/SystemUpdate.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import Widget from '@/components/Utils/Widget.vue';
import StatusDisplayer from '@/components/Utils/StatusDisplayer.vue';

@Component({
  components: {StatusDisplayer, Widget},
})
export default class SystemUpgradeWidget extends Mixins<BaseComponent>(BaseComponent) {
  private UpgradeState = UpgradeState;

  private UpgradeStateLabels = UpgradeStateLabels;

  private systemInfoStore: SystemInfoStore = getModule(SystemInfoStore, this.$store);

  private systemUpgradeStore: SystemUpgradeStore = getModule(SystemUpgradeStore, this.$store);

  private systemUpdateStore: SystemUpdateStore = getModule(SystemUpdateStore, this.$store);

  get upgradeInProgress(): boolean {

    if (!this.systemUpgradeStore.UpgradeState) {
      return false;
    }

    switch (this.systemUpgradeStore.UpgradeState as UpgradeState) {
      case UpgradeState.Idle:
      case UpgradeState.DownloadFailed:
      case UpgradeState.UploadFailed:
      case UpgradeState.Completed:
        return false;

      default:
        return true;
    }
  }

  private async mounted() {
    this.setLoading();
    try {

      await this.systemUpgradeStore.fetchState();

      await this.systemInfoStore.fetchOsInfo();
      await this.systemInfoStore.fetchHardwareInfo();
      await this.systemUpgradeStore.fetchChannel();
      await this.systemUpgradeStore.fetchRepository();

      if (!this.systemInfoStore.HardwareInfo || !this.systemInfoStore.OsInfo || !this.systemUpgradeStore.Channel) {
        return;
      }

      await this.systemUpdateStore.checkUpdateAvailable({
        osInfo: this.systemInfoStore.OsInfo,
        repository: this.systemUpgradeStore.Repository,
        channel: this.systemUpgradeStore.Channel,
      });
    } finally {
      this.setLoaded();
    }
  }
}
